import { Component } from "@angular/core";

@Component({
  selector: "menu-svg",
  templateUrl: "./menu.component.svg",
  styleUrls: ["./menu.component.scss"],
})
export class MenuSvgComponent { }
